module.exports = __webpack_public_path__ + "img/icon2.34f1e612.png";